import { render, staticRenderFns } from "./Cajas.vue?vue&type=template&id=28593788&scoped=true&lang=pug&v-slot%3Acontent=true"
import script from "./Cajas.vue?vue&type=script&lang=js"
export * from "./Cajas.vue?vue&type=script&lang=js"
import style0 from "./Cajas.vue?vue&type=style&index=0&id=28593788&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28593788",
  null
  
)

export default component.exports